<template>
	<div class="list">
		<van-overlay :show="isLoading" @click="isLoading = false">
			<div class="load_wrapper">
				<van-loading />
			</div>
		</van-overlay>

		<list
				v-for="(item, index) in list"
				:key="item.video_id"
				:title="item.video_name"
				:index="index + 1"
				:text="item.video_desc"
				:src="item.video_url"
				:img="item.img_url">
		</list>
	</div>
</template>

<script>
	import List from '@/components/listItem'

	export default {
		name: "index",
		components: {
			List
		},
		data() {
			return {
				isLoading: true,
				list: [
					{
						"video_name": "金山岭长城",
						"video_url": "http://vjs.zencdn.net/v/oceans.mp4",
						"img_url": "./image/video_img.jpg",
						"type_id": 1,
						"show_date": "132",
						"video_order": 1,
						"video_id": 1,
						"video_desc": "金山岭长城，位于河北省承德市滦平县境内，与北京市密云区相邻，距北京市区130公里。金山岭长城始建于明洪武元年（公元1368年），为大将徐达主持修建。金山岭长城，在隆庆元年（公元1567年）抗倭名将蓟镇总兵官戚继光、蓟辽总督谭纶在徐达所建长城的基础上续",
						"status": 0
					}
				]
			}
		},
		async created() {
			this.isLoading = true;
			let id = this.$route.params.id;
			const res = await this.$http.get("/yzcc/ht/api/video?id=" + id);
			if(res) {
				this.list = res.data.list;
			}
			this.isLoading = false;
		}
	}
</script>

<style scoped>
	.list {
		max-width: 800px;
		min-height: calc(100vh - 160px - 100px);
		margin: 0 auto;
	}





	@media screen and (min-width: 800px ) {
		.list {
			min-height: calc(100vh - 380px - 180px);
		}
	}
</style>